import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export default function AnimatedMap() {
    const { ref, inView } = useInView({
        triggerOnce: true, // Анимация срабатывает только один раз
        threshold: 0.6, // Срабатывание анимации, когда 60% элемента видно
    });

    useEffect(() => {
        if (window.ymaps) {
            window.ymaps.ready(initMap);
        }
    }, [])
    const initMap = () => {
        const mapElement = document.getElementById("yandex-map");
        if (mapElement && mapElement.children.length > 0) {
            return;
        }

        const map = new window.ymaps.Map("yandex-map", {
            center: [56.876368, 53.217257],
            zoom: 17,
            controls: ["zoomControl", "fullscreenControl"],
        });

        map.geoObjects.add(
            new window.ymaps.Placemark(
                [56.876368, 53.217257],
                { iconCaption: 'Turtton, Холмогорова 43' },
                { preset: "islands#StretchyIcon", iconColor: "#576acf" }
            )
        );
    };

    return (
        <div
            ref={ref}
            className={`transition-all duration-[1500ms] lg:w-[52%] aspect-video bg-no-repeat bg-cover bg-center backgorundMaps p-1.5 lg:p-3 rounded lg:rounded-xl 2xl:rounded-2xl ${inView ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-16"
                }`}
        >
            <div id="yandex-map" className="w-full h-full rounded lg:rounded-xl 2xl:rounded-3xl"></div>
        </div>
    );
}